<template>
  <v-app>
    <v-card
        color="green"
        flat
        tile
        class="align-center"
    >
      <v-toolbar style="background: #447059; height: 100px" class="align-center">
        <v-app-bar-nav-icon></v-app-bar-nav-icon>
        <v-toolbar-title style="color: darkorange; font-weight: bold; margin-left: 20px"
                         class="darkorange--text align-self-center" align="center">
          <h3 class="orange--text align-self-center">IP CHECK</h3>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
    <v-row style="margin-top: 70px; height: 3000px; overflow-y: scroll !important" class="overflow-y-scroll">
      <!--<v-col cols="1"></v-col>-->
      <v-col cols="11" class="mx-auto">
        <v-row v-if="!verified">
          <v-form style="width: 50%">
          <v-text-field
              placeholder="Passwort zur Authentifizierung"
              style="min-width: 100%"
              v-model="pw"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
          />
            <v-btn class="primary" @click="verifyPw()">SENDEN</v-btn>
          </v-form>
        </v-row>
        <v-row v-if="verified && pw === '23chh52rnch2n2020!'" style="margin-bottom: 50px">
          <v-btn @click="logout()">LOGOUT</v-btn>
        </v-row>
        <template v-if="verified && pw === '23chh52rnch2n2020!'">
          <div>
            <h1>Bitte erst lesen, bevor das IP Sheet benutzt wird</h1>
            <ul style="margin-top: 50px">
              <li><h5>Bei <strong>Anbieter</strong> kann <strong>nichts</strong> eingetragen werden,wenn mehrere
                Anbieter für die IP gespeichert werden sollen</h5></li>
              <li><h5>Zwei oder mehrere Anbieter können hintereinander weg aufgeschrieben werden unter "Anbieter". So
                kann die gleiche IP für einen anderen Kunden bei einem anderen Anbieter erneutzt genutzt werden</h5>
              </li>
              <li><h5>!! IPs für Bankkonten müssen <strong>separat</strong> gespeichert <strong>UND</strong> überprüft
                werden</h5></li>
            </ul>
            <!--<v-btn style="margin-top: 50px" @click="refreshallIps()" class="primary">Eingetragene verfügbare IPs
              abfragen
            </v-btn>
            <p>Liste zeigt Beispiele verfügbarer IPs</p>
            <v-row>
              <v-text-field
                  v-model="searchFirstTable"
                  label="Filter"
                  class="mx-4"
                  style="display: none"
              ></v-text-field>
              <v-data-table
                  v-if="verfuegbareIpsAnzeigen"
                  style="width: 100%"
                  :headers="headers"
                  :items="ipArray"
                  :search="searchFirstTable"
                  :items-per-page="5"
              >
                <template
                    v-slot:body="{ items }"
                >
                  <tr
                      v-for="(item, i) in ipArray"
                      :key="item.id"
                  >
                    <td
                        v-for="header of headers"
                        :key="header.value"
                    >
                      <template v-if="header.value === 'name'">
                        {{
                          !item[header.value].includes(" ") ? item[header.value] : item[header.value].substring(0, item[header.value].indexOf(' ') + 2)
                        }}
                      </template>
                      <template v-else>
                        {{ item[header.value] }}
                      </template>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-row>-->
            <v-row></v-row>
            <v-row>
              <v-col>
                <h4 style="margin-top: 50px">IP-VERFÜGBARKEIT PRÜFEN</h4>
                <v-col cols="12">
                  <v-text-field placeholder="IP-Adresse" v-model="ip" @change="removeIps()"
                                @input="removeIps()"></v-text-field>
                </v-col>
                <v-btn v-if="ip != null" class="primary" @click="fetchIps()">ANZEIGEN</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-text-field
                  v-model="searchSecondTable"
                  label="Filter"
                  class="mx-4"
                  style="display: none"
              ></v-text-field>
              <v-data-table
                  v-if="gefilterteIpsAnzeigen"
                  style="width: 100%"
                  :headers="headers"
                  :items="items"
                  :search="searchSecondTable"
                  :items-per-page="5"
              >
                <template
                    v-slot:body="{ items }"
                >
                  <tr
                      v-for="(item, i) in items"
                      :key="item.id"
                  >
                    <td
                        v-for="header of headers"
                        :key="header.value"
                    >
                      <template v-if="header.value === 'name'">
                        {{
                          !item[header.value].includes(" ") ? item[header.value] : item[header.value].substring(0, item[header.value].indexOf(' ') + 2)
                        }}
                      </template>
                      <template v-else>
                        {{ item[header.value] }}
                      </template>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-row>
            <v-row>
              <div>
                <v-btn style="margin-top: 50px" @click="newIp = !newIp" class="primary" v-if="gefilterteIpsAnzeigen">
                  NEUE IP ANLEGEN UND SPEICHERN
                </v-btn>
                <template v-if="newIp">
                  <p>Kundenname: Bitte aus Datenschutzgründen nur Vornamen und ersten Buchstaben vom Nachnamen
                    eintragen</p>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field placeholder="IP-Adresse" v-model="ip" readonly></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field placeholder="Kundenname" v-model="kundenname"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field placeholder="Anbieter" v-model="anbieter"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-select
                          label="Zweck"
                          :items="zwecke"
                          v-model="zweck"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-select
                      label="Bank oder Sportwetten"
                      :items="['Bank', 'Sportwetten']"
                      v-model="bankOderSportwetten"
                  ></v-select>
                  <h5 style="color: red">{{ isNotAvailable }}</h5>
                  <h5 style="color: green" v-if="isNotAvailable.length < 1">IP ist verfügbar</h5>
                  <v-btn class="primary"
                         v-if="ip != null && kundenname != null && bankOderSportwetten != null && isNotAvailable.length < 1"
                         @click="writeEntry()">SENDEN
                  </v-btn>
                  <v-btn
                      @click="dialog = true"
                      v-if="ip != null && kundenname != null && bankOderSportwetten != null &&isNotAvailable.length > 0">DIE IP IST NICHT VERFÜGBAR - MÖCHTEST DU SIE TROTZDEM SPEICHERN?</v-btn>
                  <h5 style="color: green">{{ msg }}</h5>
                </template>
              </div>
            </v-row>
          </div>
          <v-dialog v-model="dialog">
            <v-card style="max-width: 400px; padding: 30px; height: 200px; margin: auto">
              <h3>Bist du sicher, dass du die IP speichern möchtest, obwohl sie nicht verfügbar ist?</h3>
              <v-btn @click="writeEntry()">SPEICHERN</v-btn>
              <v-btn @click="dialog = false">ABBRECHEN</v-btn>
            </v-card>
          </v-dialog>
        </template>
      </v-col>
    </v-row>
    <v-footer padless absolute="absolute">
      <v-col
          class="text-center"
          cols="12"
      >
        <v-btn text>
          <!--<a href="https://klee-gold.de/impressum" class="routerLink">IMPRESSUM</a>-->
        </v-btn>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import axios from './plugins/axios'

export default {
  name: 'App',
  data: () => ({
    dialog: false,
    show1: false,
    searchFirstTable: null,
    searchSecondTable: null,
    verfuegbareIpsAnzeigen: false,
    gefilterteIpsAnzeigen: false,
    newIp: false,
    url: 'https://ipverfuegbarkeit.de/restapi/api/ipcheck.php',
    cid: null,
    loadingStatus: false,
    error: false,
    status: 1,
    pw: null,
    verified: false,
    headers: [{text: "IP", value: "ip"}, {text: "Name Kunde", value: "name"}, {
      text: "Anbieter",
      value: "anbieter"
    }, {text: "Zweck", value: "zweck"}, {text: "Bank oder Sportwetten", value: "bank_oder_sportwetten"}, {
      text: "Datum",
      value: "date_of_update"
    }],
    zwecke: ["Anmeldung/ Einzahlung", "Auszahlung", "Wetten", "Email"],
    items: [],
    ipArray: [],
    filteredIpArray: [],
    ip: null,
    kundenname: null,
    anbieter: null,
    zweck: null,
    bankOderSportwetten: null,
    msg: null,
  }),
  mounted() {
    this.getAllIps()
    fetch('https://api.ipify.org?format=json')
        .then(x => x.json())
        .then(({ip}) => {
          this.ip = ip;
          console.log('IP V4: ' + ip)
          if (this.ip == null || this.ip.length < 1) {
            fetch('https://api64.ipify.org?format=json')
                .then(x => x.json())
                .then(({ip}) => {
                  this.ip = ip;
                  console.log('IP V6: ' + ip)
                });
          }
        });
  },
  methods: {
    removeIps() {
      this.newIp = false
      this.gefilterteIpsAnzeigen = false
    },
    refreshallIps() {
      this.getAllIps()
      this.verfuegbareIpsAnzeigen = !this.verfuegbareIpsAnzeigen
    },
    writeEntry() {
      let postObj = {
        ip: this.ip,
        anbieter: this.anbieter,
        zweck: this.zweck,
        name: this.kundenname,
        bank_oder_sportwetten: this.bankOderSportwetten
      }
      let self = this
      axios.post(self.url, postObj).then((response) => self.setSuccessMsg(response))
      this.dialog = false
    },
    setSuccessMsg(response) {
      this.fetchIps()
      this.kundenname = null
      this.anbieter = null
      this.zweck = null
      this.bankOderSportwetten = null
      console.log(response)
      this.msg = "Eintrag gespeichert"
      setTimeout(() => {
        this.msg = null
      }, 3000);
    },
    fetchIps() {
      this.gefilterteIpsAnzeigen = true
      this.getRowsByIp(this.ip)
    },
    logout() {
      this.pw = null
      this.verified = false
    },
    verifyPw() {
      if(this.pw === '23chh52rnch2n2020!') { // kleegoldGehtAb2022!1357_ , 23chh52rnch2n2020!
        this.verified = true
      }
    },
    getAllIps() {
      let self = this
      axios.get(self.url).then((response) => self.setAllIps(response))
    },
    setAllIps(response) {
      console.log(response)
      if(response.data && response.data.ip_array) {
        this.ipArray = response.data.ip_array.slice(0, 5);
      }
    },
    getRowsByIp(ip) {
      console.log(ip)
      let self = this
      let postObj = {ip: ip}
      axios.post(self.url, postObj).then((response) => self.setRowsByIp(response))
    },
    setRowsByIp(response) {
      console.log(response)
      if(response.data && response.data.ip_filter) {
        this.filteredIpArray = response.data.ip_filter
        this.items = this.filteredIpArray
      }
    }
  },
  computed: {
    isNotAvailable() {
      let errorMsg = ''
      let anbieter = this.anbieter !== null ? this.anbieter : ""
      let filteredArray = this.items.filter((obj) => obj.anbieter == "" || obj.anbieter == null || (obj.anbieter != null && obj.anbieter.includes(anbieter)) || anbieter.includes(obj.anbieter))
      if(filteredArray && filteredArray.length > 0) {
        errorMsg = "IP für diesen Anbieter bereits verwendet"
      }
      return errorMsg
    }
  }
};
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   color: #2c3e50; */
  color: #2f3136;
  min-height: 100%;
  width: 100%;
  line-height: 32px;
}

.spaced {
  margin-top: 50px;
  margin-bottom: 50px;
}

.title {
  margin: 0px;
  max-width: 100%;
  font-weight: unset;
  font-size: 32px;
  line-height: 32px;
}

.subtitleClass {
  margin: 0px;
  max-width: 100%;
  font-weight: unset;
  font-size: 28px;
  line-height: 32px;
}

body, html {
  padding: 0;
  width: 100%;
  min-height: 100vh !important;
  font-family: "Roboto", sans-serif;
  line-height: 32px;
}

body {
}

.spacedBtn {
  margin-top: 100px;
}

input[type=radio]:checked ~ .check {
  border: 5px solid #0dff92;
}

input[type=radio]:checked ~ .check::before {
  background: #0dff92;
}

input[type=radio]:checked ~ label {
  color: #0dff92;
}

.uploadBtn {
  background-color: rgb(255, 165, 0);
  opacity: 0.4;
  cursor: pointer;
}

.bigfont {
  font-size: 35px;
}
</style>

